import { render, staticRenderFns } from "./DelegateOnlineCoursesGradeList.vue?vue&type=template&id=97d75f38&scoped=true"
import script from "./DelegateOnlineCoursesGradeList.vue?vue&type=script&lang=ts"
export * from "./DelegateOnlineCoursesGradeList.vue?vue&type=script&lang=ts"
import style0 from "./DelegateOnlineCoursesGradeList.vue?vue&type=style&index=0&id=97d75f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d75f38",
  null
  
)

export default component.exports